// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"354":"4709a3f9","455":"e021a6ef","488":"1a9a8f8c","614":"0c42f707","685":"729ef1fc","695":"83e6caa7","977":"a3022c91"}[chunkId] + ".chunk.js";
};